export const CREATOR_COMMENT_SYMBOL_RELATIVE_PATH =
  "assets/vectors/comments/creator_comment_symbol.svg";
